import { useRouter }  from "next/router";
import useSWRInfinite from "swr/infinite";

import toast                        from "_common/toast";
import { getReels, getShortVideos } from "_services/api/feed";

import Presentation from "./presentation";

const getKey  = ( pageIndex, previousPageData ) => {
	if ( previousPageData && !previousPageData.length ) return null; // reached the end

	return { key: `/users?page=${ pageIndex }&limit=10`, pageNo: pageIndex + 1 }; // SWR key
};
const fetcher = async ( { pageNo, pageSize, userId } ) => {
	if ( userId ) {
		let params = {
			sportsFanId : userId,
			pageNo      : pageNo,
			pageSize    : 10
		};

		return await getReels ( params );
	}

	return getShortVideos ( { pageNo, pageSize } );
};

const component = props => {

	const {
		reelById,
		error
	} = props;

	const pageSize = 10;
	const router   = useRouter ();
	const userId   = router.query.user;

	const { data, setSize, isLoading, isValidating } = useSWRInfinite ( getKey, ( { pageNo } ) => fetcher ( {
		pageSize,
		userId,
		pageNo
	} ), {
		revalidateOnFocus : false,
		onError           : error => {
			toast.error ( error.dislayMsg || "Somethin Went Wrong!" );

		}
	} );

	const uniqueObjectsSet   = data ? new Set ( [ reelById, ...data?.flat ( Infinity ) ].map ( obj => JSON.stringify ( obj ) ) ) : new Set ();
	const uniqueObjectsArray = Array.from ( uniqueObjectsSet ).map ( strObj => JSON.parse ( strObj ) );

	const finalArr = data ? uniqueObjectsArray : new Array ( 10 ).fill ( { id: "customid" } );

	function fetchMoreReels () {
		setSize ( size => {
		    return size + 1;
		} );
	}

	return (
		<Presentation
			error          = { error }
			fetchMoreReels = { fetchMoreReels }
			isLoading      = { isLoading }
			isValidating   = { isValidating }
			userReels      = { finalArr }
		/>
	);
};

export default component;
